<button mat-button type="button" [routerLink]="['/']">
  <span class="app-name">{{ "app-name" | translate }}</span>
</button>
